import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCode } from 'react-dropzone';
import { DurationErrorCode } from '../types';

const useErrorMessage = () => {
  const { t } = useTranslation();

  const getErrorMessage = useCallback(
    (errorCode: string) => {
      if (errorCode === ErrorCode.FileInvalidType) {
        return t(
          'aiMusicGenerator:userLoopUploadModal:validation:invalidFileType'
        );
      }
      if (errorCode === ErrorCode.TooManyFiles) {
        return t(
          'aiMusicGenerator:userLoopUploadModal:validation:tooManyFiles'
        );
      }
      if (errorCode === DurationErrorCode.FileTooShort) {
        return t(
          'aiMusicGenerator:userLoopUploadModal:validation:audioFileTooShort'
        );
      }
      if (errorCode === DurationErrorCode.FileTooLong) {
        return t(
          'aiMusicGenerator:userLoopUploadModal:validation:audioFileTooLong'
        );
      }

      return t('aiMusicGenerator:userLoopUploadModal:validation:generic');
    },
    [t]
  );

  return getErrorMessage;
};

export default useErrorMessage;
